import React, { useState } from "react";
import theme from "../../Styles/theme";
import Modal from "react-modal";
import { Button, Container, HandleButton, HandleInput, Input } from "./styles";
import { ModalDivX } from "../ModalDivX";
import { useCartorio } from "../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { useOperacao } from "../../Hooks/operacoes";
import api from "../../Services/api";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
}

export function AddOperacaoModal({ open, onClose }: Props) {
  const { cartorio, cartorioIsLogged, checarToken } = useCartorio();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const { handleAddOperacao } = useOperacao();

  function handleClose() {
    setDescricao("");
    onClose();
  }
  const [DESCRICAO, setDescricao] = useState("");

  async function post() {
    if (DESCRICAO.trim().length == 0) {
      setError({
        title: "Descrição inválida",
        message: "Não é permitida a criação de uma operação sem descrição!",
      });
      return;
    }

    try {
      setLoading(true);
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }
      if (cartorioIsLogged) {
        await checarToken();
      }
      const { data } = await api.post(`/tipos-operacoes`, {
        DESCRICAO,
        CARTORIO_ID: cartorio.ID,
      });

      handleAddOperacao(data);
      handleClose();
    } catch (error) {
      setError({
        title: "Ops",
        message:
          "Não foi possível cadastrar a operação, tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ModalDivX execute={handleClose} />
        <HandleInput>
          <Input
            value={DESCRICAO}
            onChange={(ev) => {
              setDescricao(ev.target.value);
            }}
            placeholder={"DESCRIÇÃO"}
          />
        </HandleInput>
        <HandleButton>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={post}>Confimar</Button>
        </HandleButton>
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => {
          setError({ title: "", message: "" });
        }}
      />
    </Modal>
  );
}
